import { render, staticRenderFns } from "./FaqTable.vue?vue&type=template&id=4ae192da&scoped=true"
import script from "./FaqTable.vue?vue&type=script&lang=ts"
export * from "./FaqTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae192da",
  null
  
)

export default component.exports